module.exports = __webpack_public_path__ + "c36d1991b52ce043a0ae18b32a4da5da.svg";